export const PackageSizes = {
    a4: 'a4',
    a6: 'a6'
}